import { render, staticRenderFns } from "./VSalary.vue?vue&type=template&id=60e596d6&"
import script from "./VSalary.vue?vue&type=script&lang=js&"
export * from "./VSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports